import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

export default class SDWanAlarms extends Component {
  constructor() {
    super();
    const removeZeros = (data) =>
      data.map((value) => (value === 0 ? null : value));
    this.state = {
      series: [
        {
          name: "Cleared",
          data: removeZeros([17]), // Ensure data length matches categories
        },
        {
          name: "Critical",
          data: removeZeros([0]),
        },
        {
          name: "Intermediate",
          data: removeZeros([22]),
        },
        {
          name: "Major",
          data: removeZeros([0]),
        },
        {
          name: "Minor",
          data: removeZeros([0]),
        },
        {
          name: "Warning",
          data: removeZeros([0]),
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          stacked: false,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "50%",
            borderRadius: 5,
            borderColor: "#FFFFFF", // Matches chart background to create gaps
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#FFFFFF"],
            fontSize: "12px",
            fontWeight: 500,
          },
          background: {
            enabled: true,
            foreColor: "#656161",
            borderRadius: 2,
            padding: 4,
            opacity: 0.9,
            borderWidth: 1,
            borderColor: "#656161",
          },
          offsetY: -20,
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: ["Cust 1"],

          labels: {
            style: {
              fontSize: "10px",
              fontWeight: 700,
              margin: {
                top: 0, // Adjust these margins to control spacing around labels
                right: 0,
                bottom: 0,
                left: 0,
              },
            },
            rotate: -30,
          },

          title: {
            // text: "Alarm Count", // Title for the x-axis
            style: {
              fontSize: "14px",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "10px",
              fontWeight: "bold",
            },
          },
          title: {
            text: "SD-Wan Alarms", // Title for the X-axis
            style: {
              fontSize: "13px",
              fontWeight: "8px",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        colors: [
          "#2797FE", // Cleared
          "#2838A6", // Critical
          "#E7794A", // Intermediate
          "#781887", // Major
          "#E255AE", // Minor
          "#805EC7", // Warning
        ],

        legend: {
          position: "bottom",
          horizontalAlign: "center",
          fontWeight: "10px",
          //   offsetX: 40,
        },
      },
    };
  }

  render() {
    return (
      <div>
        {this.props.message === "Data found" ? (
          <ReactApexChart
            options={this.state.options}
            series={this.state.series}
            type="bar"
            height={300}
          />
        ) : (
          <div
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#605E5C",
            }}
          >
            {this.props.message}
          </div>
        )}
      </div>
    );
  }
}
